export default "__VITE_ASSET__BsbZ8bs9__"